import { Action, current, PayloadAction } from '@reduxjs/toolkit';
import { LocalStorer } from 'services/localStorer';
import { DepthTypes, SimpleOffsetWellbore } from 'types/ghostMode';

import {
  GHOST_MODE_DEPTH_TYPE_LOCAL_STORAGE_KEY,
  GHOST_MODE_SELECTED_WELLS_KEY,
} from './constants';
import { GhostModeState } from './state';

export const setDepthTypeReducer = (
  state: GhostModeState,
  action: PayloadAction<{ depthType: DepthTypes }>,
) => {
  LocalStorer.set(GHOST_MODE_DEPTH_TYPE_LOCAL_STORAGE_KEY, action.payload.depthType);
  state.depthType = action.payload.depthType;
};

export const removeOffsetWellboreReducer = (
  state: GhostModeState,
  action: PayloadAction<{ tuwbi: string }>,
) => {
  const offsets = current(state).offsets.offsetWellbores.filter(
    w => w.tuwbi !== action.payload.tuwbi,
  );
  state.offsets.offsetWellbores = offsets;
  saveToLocalStorage(state.currentWellboreTuwbi, offsets);
};

export const saveToLocalStorage = (
  currentWellboreTuwbi: string,
  offsets: SimpleOffsetWellbore[],
) => {
  const localStorageKey = GHOST_MODE_SELECTED_WELLS_KEY;
  const localStorageOffsets = JSON.parse(LocalStorer.get(localStorageKey) || '{}');

  LocalStorer.set(
    localStorageKey,
    JSON.stringify({ ...localStorageOffsets, [currentWellboreTuwbi]: offsets }),
  );
};

export const setCurrentWellboreTuwbiReducer = (
  state: GhostModeState,
  action: PayloadAction<{ tuwbi: string }>,
) => {
  state.currentWellboreTuwbi = action.payload.tuwbi;
};

export const retrieveFullfilledReducer = (
  state: GhostModeState,
  action: PayloadAction<SimpleOffsetWellbore>,
) => {
  const newOffset: SimpleOffsetWellbore = action.payload;

  const offsets: SimpleOffsetWellbore[] = [...current(state).offsets.offsetWellbores, newOffset];

  saveToLocalStorage(state.currentWellboreTuwbi, offsets);

  state.offsets.loading = false;
  state.offsets.offsetWellbores = offsets;
};

export const retrieveOffsetsRejectedReducer = (state: GhostModeState, action: Action) => {
  state.offsets.loading = false;
  state.offsets.error = true;
};

export const retrieveFromLocalStorageReducer = (
  state: GhostModeState,
  action: PayloadAction<{ tuwbi: string }>,
) => {
  const localStorageOffsets = LocalStorer.get(GHOST_MODE_SELECTED_WELLS_KEY);

  state.offsets.offsetWellbores =
    JSON.parse(localStorageOffsets || '{}')[action.payload.tuwbi] || [];
};
